import React, { useContext, useEffect, useState, useMemo } from "react";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid, Box } from "@material-ui/core";
import { TextField } from "@mui/material";
import { MyContext } from './../../../context/MyContext';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import { DataGrid } from '@mui/x-data-grid';
import { BrowserView, MobileView } from 'react-device-detect';
import api from '../../../services/api';
import * as locales from '@mui/material/locale';
import './PaginaEndereco.css'
// import Button from '@mui/material/Button';
import axios from 'axios';
// import Typography from '@mui/material/Typography';
// import { Grid, Box } from "@material-ui/core";
// import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
// import { MobileView } from "react-device-detect";

const style = {
  position: 'absolute',
  top: '10%',
  left: '10%',
  right: "10%",
  overflow: 'scroll',
  height: '100%',
  display: 'block',
  bgcolor: 'background.paper',
  boxShadow: 24
}

export default function ModalDetalhes(props) {
  const [open, setOpen] = React.useState(false);
  const produto = props?.props;

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const idCliente = props?.props;  // Concatenado Id_Loja
  const { meuEnderecoEntrega, setMeuEnderecoEntrega } = useContext(MyContext);
  const { atualizarPagina, setAtualizarPagina } = useContext(MyContext);
  const { meuCredito, setMeuCredito } = useContext(MyContext);
  const [cidadeSelecionada, setCidadeSelecionada] = useState(0);
  const [meusEnderecos, setMeusEnderecos] = useState([]);
  const [locale, setLocale] = useState('ptBR');
  const theme = useTheme();
  const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
  const [fretes, setFretes] = useState([]);
  const [freteError, setFreteError] = useState("");
  const [idsEnderecos, setIdsEnderecos] = useState(0);
  const [idsLojaEnderecos, setIdsLojaEnderecos] = useState(0);
  const [idClientesEnderecos, setIdClientesEnderecos] = useState(0);
  const [idLojaEnderecos, setIdLojaEnderecos] = useState(0);
  const [bacen, setBacen] = useState("");
  const [apelidoEnd, setApelidoEnd] = useState("WEBSITE");
  const [rua, setRua] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [iduf, setIduf] = useState(0);
  const [uf, setUf] = useState("");
  const [idcidade, setIdcidade] = useState(0);
  const [cidade, setCidade] = useState("");
  const [cep, setCep] = useState("");
  const [referencia, setReferencia] = useState("");
  const [padraoEnderecos, setPadraoEnderecos] = useState(0);
  const [ativoEnderecos, setAtivoEnderecos] = useState(1);
  const [extUf, setExtUf] = useState("");
  const [extCidade, setExtCidade] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [botaoPadrao, setBotaoPadrao] = useState(true);
  const [editarReadOnly, setEditarReadOnly] = useState(true);
  const [enderecoSelecionado, setEnderecoSelecionado] = useState([]);
  setAtualizarPagina(false);

  const [tabela, setTabela] = useState({
    ids_enderecos: "",
    ids_loja_ederecos: "",
    id_clientes_enderecos: "",
    id_loja_enderecos: "",
    bacen: "",
    apelido_end: "",
    rua: "",
    numero: "",
    complemento: "",
    bairro: "",
    iduf: "",
    idcidade: "",
    cep: "",
    referencia: "",
    padrao_enderecos: "",
    ativo_enderecos: 1,
    ext_uf: "",
    ext_cidade: "",
    latitude: "",
    longitude: ""
  });

  useEffect(() => {
    BuscarMeusEnderecos();
  }, [rua, numero, cidade, uf, editarReadOnly]);

  function BuscarMeusEnderecos() {
    if (idCliente == null || idCliente == "" || idCliente.length == 0) {
      return;
    }
    if (idCliente.indexOf('_') == -1) {
      return;
    }
    api.get(`/Fretes/MeusEnderecos/` + idCliente.split('_')[0] + `/` + idCliente.split('_')[1])
      .then((response) => {
        if (response === null) {
          return;
        }
        setMeusEnderecos(response.data);
      })
      .catch((error) => {
        console.log(error.message)
      });
  }

  function Edicao(e) {
    if (editarReadOnly == false) {
      setEditarReadOnly(true);
    }
    else {
      setEditarReadOnly(false);
    }
  }

  function Novo(e) {
    if (editarReadOnly == false) {
      setEditarReadOnly(true);
    }
    else {
      setEditarReadOnly(false);
      setIdsEnderecos(0);
      setIdsLojaEnderecos(998);
      setIdClientesEnderecos(Number(idCliente.split('_')[0]));
      setIdLojaEnderecos(Number(idCliente.split('_')[1]));
      setBacen(1058);
      setApelidoEnd("WEBSITE");
      setRua("");
      setNumero("");
      setComplemento("");
      setBairro("");
      setIduf(0);
      setUf("");
      setIdcidade(0);
      setCidade("");
      setCep("");
      setReferencia("");
      setPadraoEnderecos(0);
      setAtivoEnderecos(1);
      setExtUf("");
      setExtCidade("");
      setLatitude("");
      setLongitude("");
      setBotaoPadrao(false);
      document.getElementById("cepFrete").focus();
    }
  }

  function Cancelar(e) {
    e.preventDefault();
    setEditarReadOnly(true);
  }

  function Selecionar(e) {
    e.preventDefault();
    setEditarReadOnly(true);
    if (meuEnderecoEntrega === null || meuEnderecoEntrega === 'undefined') {
      return;
    }
    const selecioneiEndereco = meuEnderecoEntrega;
    selecioneiEndereco.enderecos.idsEnderecos = idsEnderecos;
    selecioneiEndereco.enderecos.idsLojaEnderecos = idsLojaEnderecos;
    selecioneiEndereco.enderecos.idClientesEnderecos = idClientesEnderecos;
    selecioneiEndereco.enderecos.idLojaEnderecos = idLojaEnderecos;
    selecioneiEndereco.enderecos.rua = rua;
    selecioneiEndereco.enderecos.cep = cep.toString().replaceAll("-", "");
    selecioneiEndereco.enderecos.numero = numero;
    selecioneiEndereco.enderecos.bacen = bacen;
    selecioneiEndereco.enderecos.bairro = bairro;
    selecioneiEndereco.enderecos.idcidade = idcidade;
    selecioneiEndereco.enderecos.iduf = iduf;
    selecioneiEndereco.enderecos.enderecoCidade = cidade;
    selecioneiEndereco.enderecos.enderecoUF = uf;
    selecioneiEndereco.enderecoCidade = cidade;
    selecioneiEndereco.enderecoUF = uf;
    setMeuEnderecoEntrega(selecioneiEndereco);
    setCep(selecioneiEndereco.enderecos.cep);
    window.setCookie('nafil_endereco_entrega', "UYTsa32" + Buffer.from(JSON.stringify(selecioneiEndereco)).toString('base64'), 365);
    window.setCookie('nafil_ultimo_cep', selecioneiEndereco.enderecos.cep, 365);
    setAtualizarPagina(true);
    setOpen(false);
  }

  function Salvar(e) {
    e.preventDefault();
    setEditarReadOnly(true);
    const envioDB = tabela;
    envioDB.IdsEnderecos = idsEnderecos;
    envioDB.IdsLojaEnderecos = idsLojaEnderecos;
    envioDB.IdClientesEnderecos = idClientesEnderecos;
    envioDB.IdLojaEnderecos = idLojaEnderecos;
    envioDB.Bacen = bacen;
    envioDB.ApelidoEnd = apelidoEnd;
    envioDB.Rua = rua;
    envioDB.Numero = numero;
    envioDB.Complemento = complemento;
    envioDB.Bairro = bairro;
    envioDB.Iduf = iduf;
    envioDB.Idcidade = idcidade;
    envioDB.Cep = cep;
    envioDB.Referencia = referencia;
    envioDB.PadraoEnderecos = padraoEnderecos;
    envioDB.AtivoEnderecos = ativoEnderecos;
    envioDB.ExtUf = "";
    envioDB.ExtCidade = "";
    envioDB.Latitude = latitude;
    envioDB.Longitude = longitude;



    setTabela(envioDB);
    setFreteError("");
    if (bacen.length === 0) {
      setFreteError("Código do País Inválido");
      return;
    }
    else if (rua.length === 0) {
      setFreteError("Logradouro Inválido");
      return;
    }
    else if (numero.length === 0) {
      setFreteError("Número Inválido, Sem Número Utilize S/N");
      return;
    }
    else if (bairro.length === 0) {
      setFreteError("Bairro Inválido");
      return;
    }
    else if (iduf <= 0) {
      setFreteError("Estado UF Inválido");
      return;
    }
    else if (idcidade <= 0) {
      setFreteError("Cidade Inválida");
      return;
    }
    else if (cep.length < 8) {
      setFreteError("CEP Inválido");
      return;
    }
    else if (idsEnderecos == null || idsEnderecos == 0) {
      setFreteError("Registro Inválido");
      return;
    }
    api.post(`/Fretes/MeusEnderecos/Salvar/` + idCliente.split('_')[0] + `/` + idCliente.split('_')[1], tabela)
      .then((response) => {
        return response;
      })
      .then((data) => {
        // setFreteError("FALHA AO SALVAR A: " + data?.data);
      })
      .catch((error) => {
        if (error.toString().includes("500")) {
          setFreteError("ENDEREÇO JÁ FOI CADASTRADO ANTERIORMENTE");
        }
        else {
          setFreteError("FALHA AO SALVAR: " + error);
        }
      });
  }

  const changeCEP = (e) => {
    setCep(e.target.value);
  }

  const changeReferencia = (e) => {
    setReferencia(e.target.value);
  }

  const changeComplemento = (e) => {
    setComplemento(e.target.value);
  }

  const changeNumero = (e) => {
    setNumero(e.target.value);
  }

  const SelecionaEndereco = (e) => {
    if (e != null && e.row != null) {
      setFreteError("");
      setEnderecoSelecionado(e.row);
      setCep(e?.row?.enderecos?.cep.substr(0, 5) + '-' + e?.row?.enderecos?.cep.substr(5, 3));
      setCidade(e?.row?.enderecoCidade);
      setUf(e?.row?.enderecoUF);
      setIdsEnderecos(e?.row?.enderecos?.ids_enderecos);
      setIdsLojaEnderecos(e?.row?.enderecos?.ids_loja_enderecos);
      setIdClientesEnderecos(Number(idCliente.split('_')[0]));
      setIdLojaEnderecos(Number(idCliente.split('_')[1]));
      setBacen(e?.row?.enderecos?.bacen <= 0 ? 1058 : e?.row?.enderecos?.bacen);
      setApelidoEnd(e?.row?.enderecos?.apelido_end == "" ? "WEBSITE" : e?.row?.enderecos?.apelid_end);
      setRua(e?.row?.enderecos?.rua);
      setNumero(e?.row?.enderecos?.numero);
      setBairro(e?.row?.enderecos?.bairro);
      setComplemento(e?.row?.enderecos?.complemento);
      setIduf(e?.row?.enderecos?.iduf);
      setIdcidade(e?.row?.enderecos?.idcidade);
      setReferencia(e?.row?.enderecos?.referencia);
      setPadraoEnderecos(e?.row?.enderecos?.padrao_enderecos);
      setAtivoEnderecos(e?.row?.enderecos?.ativo_enderecos);
      setExtUf(e?.row?.enderecos?.extuf);
      setExtCidade(e?.row?.enderecos?.extcidade);
      setLatitude(e?.row?.enderecos?.latitude);
      setLongitude(e?.row?.enderecos?.longitude);
      setBotaoPadrao(e?.row?.enderecos?.padrao_enderecos == 1 ? true : false);
    }
  }

  const localizedTextsMap = {
    columnMenuUnsort: "Não Ordenado",
    columnMenuSortAsc: "Ordem Crescente",
    columnMenuSortDesc: "Ordem Cecrescente",
    columnMenuFilter: "Filtro",
    columnMenuHideColumn: "Ocultar",
    columnMenuShowColumns: "Mostrar Colunas",
    columnHeaderSortIconLabel: 'Ordenar',
    noRowsLabel: 'Nenhum Endereço',
    footerTotalRows: 'Total de Linhas:',
    filterPanelOperators: 'Operador',
    filterPanelColumns: 'Coluna',
    filterPanelInputLabel: 'Valor',
    filterOperatorContains: 'contém',
    filterOperatorEquals: 'igual',
    filterOperatorStartsWith: 'começa com',
    filterOperatorEndsWith: 'termina com',
    filterOperatorIs: 'é',
    filterOperatorNot: 'não é',
    filterOperatorAfter: 'depois de',
    filterOperatorOnOrAfter: 'igual ou depois',
    filterOperatorBefore: 'antes de',
    filterOperatorOnOrBefore: 'igual ou antes',
    filterOperatorIsEmpty: 'é vazio',
    filterOperatorIsNotEmpty: 'não é vazio',
    filterOperatorIsAnyOf: 'é qualquer um',
    filterPanelInputPlaceholder: 'Pesquisar',
    toolbarFiltersTooltipActive: (count) =>
      count !== 1 ? `${count} filtro ativo` : `${count} filtros ativos`,
    footerTotalVisibleRows: (visibleCount, totalCount) =>
      `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

    footerRowSelected: (count) =>
      count !== 1
        ? `${count.toLocaleString()} Linhas Selecionadas`
        : `${count.toLocaleString()} Linha Selecionada`,
  };

  const BotaoPersonalizadoFrete = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '11px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#0063cc',
    borderColor: '#0063cc',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#0069d9',
      borderColor: '#0062cc',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });

  const BotaoPersonalizadoComprar = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '11px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#008000',
    borderColor: '#008000',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#008000',
      borderColor: '#008000',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#008000',
      borderColor: '#008000',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });

  function PesquisarCEP(value, event) {
    if (event != null && event.key == "Backspace") {
      if (value.replace("-", "").length == 6) {
        value = value.substr(0, 5);
        return;
      }
      return;
    }
    else {
      if (event != null && event.key != "Delete" && event.key != "Tab" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
        event.preventDefault();
        return;
      }
    }
    if (value != null && value.indexOf('-') == -1 && value.replaceAll("-", "").length == 5) {
      var antes = document.getElementById("cepFrete");
      antes.value = value + "-";
      setFretes([]);
      setFreteError("");
      setCep(antes.value);
    }
    if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
      var antes = document.getElementById("cepFrete");
      antes.value = value.replace("-", "");
      setFretes([]);
      setFreteError("");
    }
    if (value != null && value.length == 9) {
      // CEP 27281-510 = 9
      var cepSemFormatacao = value.replaceAll("-", "");
      setCep(value);
      setFreteError("Aguarde");
      obterEnderecoViaCep(cepSemFormatacao);
      window.setCookie('nafil_ultimo_cep', cepSemFormatacao, 365);
    }
    if (value != null && value.length != 9) {
      setFretes([]);
      setFreteError("");
    }
  }

  const apiCep = axios.create({
    baseURL: "https://viacep.com.br/ws/"
  });

  function obterEnderecoViaCep(cep) {
    apiCep.get(`${cep}/json`).then(response => {
      setRua(response.data.logradouro.toUpperCase());
      setCidade(response.data.localidade.toUpperCase());
      setUf(response.data.uf.toUpperCase());
      setIduf(Number(response.data.ibge.substr(0, 2)));
      setIdcidade(Number(response.data.ibge));
      setBairro(response.data.bairro.toUpperCase());
      setFreteError("");
      window.setCookie('nafil_ultimo_cep', cep, 365);
    }).catch(err => {
      setFreteError("CEP Não Localizado");
    });
  }
  const columns = [
    {
      field: 'enderecos.rua', headerName: 'Logradouro', width: 350, editable: true,
      valueGetter: (params) =>
        `${params.row.enderecos.rua || ''}`,
    },
    {
      field: 'enderecos?.numero', headerName: 'Número', width: 120, editable: true,
      valueGetter: (params) =>
        `${params.row.enderecos.numero || ''}`,
    },
    {
      field: 'bairro',
      headerName: 'Bairro',
      width: 150,
      editable: false,
      valueGetter: (params) =>
        `${params.row.enderecos.bairro || ''}`
    },
    {
      field: 'enderecoCidade',
      headerName: 'Cidade - UF',
      width: 200,
      editable: true,
      valueGetter: (params) =>
        `${params.row.enderecoCidade || ''} - ${params.row.enderecoUF || ''}`,
    },
    {
      field: 'cep',
      headerName: 'CEP',
      width: 100,
      editable: false,
      valueGetter: (params) =>
        `${params?.row?.enderecos?.cep?.substr(0, 5) + '-' + params?.row?.enderecos?.cep?.substr(5) || ''}`
    },
    {
      field: 'confirmado',
      headerName: 'Padrão',
      width: 60,
      renderCell: (params) => (
        params?.row?.enderecos?.padrao_enderecos === 1 ? '✔' : ''
      ),
    }
  ];

  const themeTextFieldDisabled = createTheme({
    palette: {
      label: {
        disabled: '#FF0000'
      },

      text: {
        disabled: '#000'
      }
    },
  });

  const stylesLabelDisabled = {
    floatingLabelFocusStyle: {
      color: "#FF0000"
    }
  }

  const StyledTextField = styled(TextField)({
    "& label": {
      color: "#000"
    },
    "&:hover label": {
      fontWeight: 300,
      color: "#1976d2ff"
    },
    "& label.Mui-focused": {
      color: "#1976d2ff"
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#c7c7c7ff"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#c7c7c7ff"
      },
      "&:hover fieldset": {
        borderColor: "#1976d2ff",
        borderWidth: 2
      },
      "&.Mui-focused fieldset": {
        borderColor: "#c7c7c7ff"
      }
    }
  });

  return (
    <div>
      <BrowserView>
        <Box marginRight={"4px"}>
          <Button variant="contained" onClick={(e) => handleOpen(e)} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '20px' }}>MEUS ENDEREÇOS</Button>
        </Box>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              {/* <DetalhesEndereco props={produto} handleClose={handleClose}/> */}

              {/* return ( */}
              <ThemeProvider theme={themeWithLocale}>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={3}
                >
                  <Grid item xs={12} Height={'300px'} >
                    <Box height={'300px'}>
                      <DataGrid
                        headerHeight={35}
                        Height={6}
                        getRowId={(meu) => meu.enderecoId_Endereco_Loja}
                        rows={meusEnderecos}
                        disableMultipleSelection={true}
                        onCellClick={(e) => {
                          SelecionaEndereco(e);
                        }
                        }
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        rowHeight={34}
                        rowSelection={'single'}
                        checkboxSelection={false}
                        localeText={localizedTextsMap}
                        sx={{ fontSize: '12px', fontWeight: 'bold', marginLeft: '10px', marginTop: '10px', marginRight: '10px' }}
                        hideFooterSelectedRowCount
                        disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} >
                    <Typography sx={{ marginLeft: '10px' }}><b>Entregar Nesse Endereço:</b></Typography>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    alignItems="baseline"
                    spacing={2}
                  >
                    <Grid item xs={2}>
                      <Box sx={{ minWidth: "143px" }}>
                        <TextField id="cepFrete" name="cepFrete" sx={{ marginLeft: '24px' }}
                          onKeyUp={(event) => {
                            PesquisarCEP(event.target.value, event)
                          }}
                          onChange={changeCEP}
                          inputProps={{ maxLength: 9, readOnly: editarReadOnly }}
                          label="Digite Seu CEP" variant="outlined" size="small"
                          value={cep} />
                      </Box>
                    </Grid>

                    <ThemeProvider theme={themeTextFieldDisabled}>
                      <Grid item xs={2.7} >
                        <Box sx={{ minWidth: "220px" }}>
                          <StyledTextField id="textCidade" label="Cidade - UF" variant="outlined" size="small" InputProps={{
                            readOnly: true,
                          }} defaultValue={cidade + " - " + uf} value={cidade + " - " + uf} disabled />
                        </Box>
                      </Grid>

                      <Grid item xs={5}>
                        <Box sx={{ minWidth: "450px" }}  >
                          <StyledTextField id="textLogradouro" label="Logradouro" variant="outlined" size="small" InputProps={{
                            readOnly: true,
                          }} defaultValue={rua} value={rua} fullWidth disabled
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={2.00}>
                        <Box sx={{ minWidth: "150px" }}  >
                          <StyledTextField id="textBairro" label="Bairro" variant="outlined" size="small" InputProps={{
                            readOnly: true,
                          }} defaultValue={bairro} value={bairro} fullWidth disabled
                          />
                        </Box>
                      </Grid>

                    </ThemeProvider>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    alignItems="baseline"
                    spacing={2}
                  >
                    <Grid item xs={2}>
                      <Box sx={{ minWidth: "100px", marginTop: "15px", marginLeft: "24px" }}>
                        <TextField id="textNumero" name="textNumero"
                          label="Numero" variant="outlined" size="small" value={numero} minWidth="100px" fullWidth
                          onChange={changeNumero}
                          InputProps={{
                            readOnly: editarReadOnly
                          }} />
                      </Box>
                    </Grid>

                    <Grid item xs={4}>
                      <Box sx={{ minWidth: "350px", marginTop: "15px" }}>
                        <TextField id="textComplemento" name="textComplemento"
                          label="Complemento" variant="outlined" size="small" value={complemento} minWidth="350px" fullWidth
                          onChange={changeComplemento}
                          InputProps={{
                            readOnly: editarReadOnly
                          }} />
                      </Box>
                    </Grid>

                    <Grid item xs={6}>
                      <Box sx={{ maxWidth: "515px", marginTop: "15px" }}>
                        <TextField id="textReferencia" name="textReferencia"
                          label="Referência" variant="outlined" size="small" fullWidth value={referencia}
                          onChange={changeReferencia}
                          InputProps={{
                            readOnly: editarReadOnly,
                          }} />
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={1.5}>
                      <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }} disabled>EXCLUIR</Button>
                    </Grid>
                    <Grid item xs={1.5}>
                      <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }} disabled={botaoPadrao} >PADRÃO</Button>
                    </Grid>
                    <Grid item xs={1.5}>
                      {
                        editarReadOnly == true ?
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Novo(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>NOVO</Button>
                          :
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Cancelar(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>CANCELAR</Button>
                      }
                    </Grid>
                    <Grid item xs={1.5}>
                      {
                        editarReadOnly == true ?
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Edicao(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>EDITAR</Button>
                          :
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Salvar(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>SALVAR</Button>
                      }
                    </Grid>
                    <Grid item xs={1.5}>
                      <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Selecionar(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>SELECIONAR</Button>
                    </Grid>

                    <Grid item xs={1.5}>
                      <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { handleClose() }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>FECHAR</Button>
                    </Grid>
                  </Grid>

                  <Grid item container xs={12} justifyContent="center" alignItems="center">
                    <Typography sx={{ color: "#f44336" }}>{freteError}</Typography>
                  </Grid>

                </Grid>

              </ThemeProvider>
              {/* ) */}
            </Box>
          </Fade>
        </Modal>
      </BrowserView>

      <MobileView>
        <Box marginRight={"4px"}>
          <Button variant="contained" onClick={(e) => handleOpen(e)} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '20px', minWidth: '90px' }}>ENDEREÇOS</Button>
        </Box>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              {/* <DetalhesEndereco props={produto} handleClose={handleClose}/> */}

              {/* return ( */}
              <ThemeProvider theme={themeWithLocale}>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={3}
                >
                  <Grid item xs={12} Height={'300px'} >
                    <Box height={'300px'}>
                      <DataGrid
                        headerHeight={35}
                        Height={6}
                        getRowId={(meu) => meu.enderecoId_Endereco_Loja}
                        rows={meusEnderecos}
                        disableMultipleSelection={true}
                        onCellClick={(e) => {
                          SelecionaEndereco(e);
                        }
                        }
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        rowHeight={34}
                        rowSelection={'single'}
                        checkboxSelection={false}
                        localeText={localizedTextsMap}
                        sx={{ fontSize: '12px', fontWeight: 'bold', marginLeft: '10px', marginTop: '10px', marginRight: '10px' }}
                        hideFooterSelectedRowCount
                        disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} >
                    <Typography sx={{ marginLeft: '10px' }}><b>Entregar Nesse Endereço:</b></Typography>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    alignItems="baseline"
                    spacing={2}
                  >
                    <Grid item xs={12}>
                      <Box sx={{ minWidth: "113px" }}>
                        <TextField id="cepFrete" name="cepFrete" sx={{ marginLeft: '24px' }}
                          onKeyUp={(event) => {
                            PesquisarCEP(event.target.value, event)
                          }}
                          onChange={changeCEP}
                          inputProps={{ maxLength: 9, readOnly: editarReadOnly }}
                          label="Digite Seu CEP" variant="outlined" size="small"
                          value={cep} />
                      </Box>
                    </Grid>

                    <ThemeProvider theme={themeTextFieldDisabled}>
                      <Grid item xs={12} >
                        <Box sx={{ minWidth: "290px", marginLeft: "10px" }}>
                          <StyledTextField id="textCidade" label="Cidade - UF" variant="outlined" size="small" InputProps={{
                            readOnly: true,
                          }} defaultValue={cidade + " - " + uf} value={cidade + " - " + uf} disabled />
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box sx={{ minWidth: "250px", marginLeft: "10px" }}  >
                          <StyledTextField id="textLogradouro" label="Logradouro" variant="outlined" size="small" InputProps={{
                            readOnly: true,
                          }} defaultValue={rua} value={rua} fullWidth disabled
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box sx={{ minWidth: "150px", marginLeft: "10px" }}  >
                          <StyledTextField id="textBairro" label="Bairro" variant="outlined" size="small" InputProps={{
                            readOnly: true,
                          }} defaultValue={bairro} value={bairro} fullWidth disabled
                          />
                        </Box>
                      </Grid>

                    </ThemeProvider>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    alignItems="baseline"
                    spacing={2}
                  >
                    <Grid item xs={12}>
                      <Box sx={{ minWidth: "100px", marginTop: "15px", marginLeft: "10px" }}>
                        <TextField id="textNumero" name="textNumero"
                          label="Numero" variant="outlined" size="small" value={numero} minWidth="100px" fullWidth
                          onChange={changeNumero}
                          InputProps={{
                            readOnly: editarReadOnly
                          }} />
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box sx={{ minWidth: "350px", marginLeft: "10px" }}>
                        <TextField id="textComplemento" name="textComplemento"
                          label="Complemento" variant="outlined" size="small" value={complemento} minWidth="350px" fullWidth
                          onChange={changeComplemento}
                          InputProps={{
                            readOnly: editarReadOnly
                          }} />
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box sx={{ maxWidth: "515px", marginLeft: "10px" }}>
                        <TextField id="textReferencia" name="textReferencia"
                          label="Referência" variant="outlined" size="small" fullWidth value={referencia}
                          onChange={changeReferencia}
                          InputProps={{
                            readOnly: editarReadOnly,
                          }} />
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={4}>
                      <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }} disabled>EXCLUIR</Button>
                    </Grid>
                    <Grid item xs={4}>
                      <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }} disabled={botaoPadrao} >PADRÃO</Button>
                    </Grid>
                    <Grid item xs={4}>
                      {
                        editarReadOnly == true ?
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Novo(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>NOVO</Button>
                          :
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Cancelar(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>CANCELAR</Button>
                      }
                    </Grid>
                    <Grid item xs={4}>
                      {
                        editarReadOnly == true ?
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Edicao(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>EDITAR</Button>
                          :
                          <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Salvar(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>SALVAR</Button>
                      }
                    </Grid>
                    <Grid item xs={4}>
                      <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { Selecionar(e) }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>SELECIONAR</Button>
                    </Grid>

                    <Grid item xs={4}>
                      <Button variant="contained" disabled={(meusEnderecos.length > 0 ? false : true)} onClick={(e) => { handleClose() }} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '11px', minWidth: '85px' }}>FECHAR</Button>
                    </Grid>
                  </Grid>

                  <Grid item container xs={12} justifyContent="center" alignItems="center">
                    <Typography sx={{ color: "#f44336" }}>{freteError}</Typography>
                  </Grid>

                </Grid>

              </ThemeProvider>
              {/* ) */}
            </Box>
          </Fade>
        </Modal>
      </MobileView>

    </div>
  );
}
